<template>
  <div class="live_login">
    <form>
    <div class="live_login_pass">
      <h2 class="live_login_title">替换手机号</h2>
      <div class="live_login_nav">
        <a-steps size="small" :current="changecurrent">
          <a-step title="账户确认" disabled/>
          <a-step title="绑定新号" disabled/>
          <a-step title="重置完成" disabled/>
        </a-steps>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 0">
        <p>
          <span>+86(中国大陆)</span>
          <input type="text" maxlength="11" @input="phonenumber=phonenumber.replace(/[^\d]/g,'')" v-model="phonenumber" placeholder="请输入您的手机号">
        </p>
        <p class="p2">
          <a-input placeholder="图片验证码" v-model:value="verify"/>
          <span class="p2_right">
            <img :src="urlcodeimg" alt="loading">
            <span @click="imgVerification">
              <i>看不清？</i>
            </span>
          </span>
        </p>
        <p class="p3">
          <input type="text" v-model="verificationcode" name="code" placeholder="请输入验证码" @input="verificationcode=verificationcode.replace(/[^\d]/g,'')">
          <a-button @click="handlersendcode" :disabled="isCountDown" :class="{mask:isCountDown}">{{isCountDown?Count:"发送验证码"}}</a-button>
        </p>
        <div @click="handlernext1" >
          <a-button type="primary" style="width:100%" :disabled="isboolablednext">
            下一步
          </a-button>
        </div>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 1">
        <p>
          <span>+86(中国大陆)</span>
          <input type="text" maxlength="11" @input="phonenew=phonenew.replace(/[^\d]/g,'')" v-model="phonenew" placeholder="请输入您的手机号">
        </p>
        <p class="p3">
          <input type="text" v-model="verificationcode2" name="code" placeholder="请输入验证码" @input="verificationcode=verificationcode.replace(/[^\d]/g,'')">
          <a-button @click="handlersendcode2" :disabled="isCountDown" :class="{mask:isCountDown}">{{isCountDown?Count:"发送验证码"}}</a-button>
        </p>       
        <div class="live_login_regester" @click="handlernext2">
          <a-button type="primary" style="width:100%;">
            下一步
          </a-button>
        </div>
      </div>
      <div class="live_regester_input" v-if="changecurrent == 2">
        <span class="span1">
          密码重置完成，正在返回登录页面!
          <SyncOutlined spin />
        </span>

      </div>
      <div style="text-align: right;user-select: none;">
        <span @click="handlerbacklogin" style="cursor: pointer;">返回登录</span>
      </div>
    </div>
    </form>
  </div>
</template>
<script>
import {ExclamationCircleOutlined,SyncOutlined} from '@ant-design/icons-vue';
import {notification} from 'ant-design-vue';
import {getImageCode,verificationPhoneIsBinding,sendSMSCode,modifyPhonePre,modifyPhone,isPhoneExist} from '@/api/api'
import {methodCallback} from '@/api/methodCallback'
export default {
  components: {
    ExclamationCircleOutlined,
    SyncOutlined
  },
  data() {
    return {
      changecurrent: 0, //操作步骤
      phonenumber: "", // 手机号
      verificationcode: "", //手机验证码
      verify: '', // 图片验证码
      codeid: "", // 验证码图片id
      urlcodeimg: "", // 验证码图片地址
      number: 60, // 短信验证倒计时
      Count: "(60s)",
      isCountDown: false, // 触发倒计时
      phonenew: "", // 新手机号
      verificationcode2: '',//新手机号验证码
      isboolabled: true, // 第二部
      isboolablednext: true, // 第一部
      modifyPhoneUid: '', //修改手机号唯一标识
      idss: ''
    }
  },
  watch: {
  },
  mounted() {
    this.imgVerification()
    // //防止页面后退
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
      history.pushState(null, null, document.URL);
    });
  },
  methods: {
    //图片验证码
    imgVerification(){
    	let data = {
    		width: 80,
    		height: 30,
    		codeType: 4
    	}
    	getImageCode(data)
    		.then((res) => {
    			this.urlcodeimg = res.data.data.code
    			this.codeid = res.data.data.uid
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //确认账号
    handlersendcode() {
      if (this.phonenumber == "") {
        notification.warning({
          message: '警告！',
          description: "手机号不能为空",
          duration: 2,
          key: "24",
          top: '20px',
        });
        return
      }
      if (this.verify == "") {
        notification.warning({
          message: '警告！',
          description: "图片验证码不能为空",
          duration: 2,
          key: "25",
          top: '20px',
        });
        return
      }
      this.verificationbinding()
    },
    //验证手机号与账号是否绑定 
    verificationbinding(){
      let data = {
        phone: this.phonenumber,
      }
      verificationPhoneIsBinding(data)
    		.then((res) => {
          if(res.data.code == "SUCCESS"){
            this.sendInformation(0);
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //发送短信接口
    sendInformation(number){
      let data = {
        codeType: 4
      }
      if(number == 0){
        data = {...data,phone: this.phonenumber}
      }
      if(number == 1){
        data = {...data,phone: this.phonenew}
      }
    	sendSMSCode(data)
    		.then((res) => {
    			if(res.data.code == "SUCCESS"){
    				this.countdown();
            this.isboolablednext = false
    				notification.success({
    					message: '提示！',
    					description: "验证码发送成功",
    					duration: 2,
    					key: "26",
    					top: '20px',
    				});
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //发送验证码倒计时
    countdown(){
      this.isCountDown = true
      let num = this.number
      this.idss = setInterval(() => {
        num -= 1
        this.Count = `(${num}s)`
        if (num <= 0) {
          this.isCountDown = false
          clearInterval(this.idss)
        }
      }, 1000);
    },
    //步骤条一的操作
    handlernext1() {
    	if (this.verificationcode == "") {
    		notification.warning({
    			message: '警告！',
    			description: "手机短信验证码不能为空",
    			duration: 2,
    			key: "27",
    			top: '20px',
    		});
    		return
    	}
      clearInterval(this.idss)
      this.Preconditions();
      this.isCountDown = false;
      this.Count = "(60s)";
    },
    //手机号前置条件
    Preconditions(){
    	let data = {
    		phone: this.phonenumber,
    		code: this.verificationcode,
    		imageUid: this.codeid,
        imageCode: this.verify
    	}
    	modifyPhonePre(data)
    		.then((res) => {
          if(res.data.code == "SUCCESS"){
            this.modifyPhoneUid = res.data.data.modifyPhoneUid;
            this.changecurrent = 1;
          }else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //步骤二发送验证码
    handlersendcode2(){
      if (this.phonenew == "") {
        notification.warning({
          message: '警告！',
          description: "手机号不能为空",
          duration: 2,
          key: "28",
          top: '20px',
        });
        return
      }
      this.judgeUser();
    },
    //判断用户是否存
    judgeUser(){
    	let data = {
    		phone: this.phonenew
    	}
    	isPhoneExist(data)
    		.then((res) => {
    			if (res.data.code == "NOT_FOUND_DATA") {
            this.sendInformation(1);
    			}else if(res.data.code == "PHONE_EXIST"){
    				notification.warning({
    					message: '警告！',
    					description: "手机号已存在,请更换手机号",
    					duration: 2,
    					key: "29",
    					top: '20px',
    				});
    			}else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //步骤条二的操作
    handlernext2() {
    	if (this.verificationcode2 == "") {
    		notification.warning({
    			message: '警告！',
    			description: "手机短信验证码不能为空",
    			duration: 2,
    			key: "30",
    			top: '20px',
    		});
    		return
    	}
      this.modifyPhonecondition();
    },
    //修改手机
    modifyPhonecondition(){
    	let data = {
    		modifyPhoneUid: this.modifyPhoneUid,
    		phone: this.phonenew,
    		code: this.verificationcode2
    	}
    	modifyPhone(data)
    		.then((res) => {
          if(res.data.code == "SUCCESS"){
            this.changecurrent = 2;
            let ids = setTimeout(() => {
              this.handlerbacklogin()
              clearTimeout(ids)
            }, 3000);
          }else{
            methodCallback(res);
          }
    		})
    		.catch((err) => {
    			console.log(err)
    		});
    },
    //返回登录
    handlerbacklogin() {
      localStorage.removeItem("token")
      this.$router.replace({ name: "login" })
      this.changecurrent = 0;
    },
  }
}
</script>
<style lang="less">
.live_login {
  height: 100%;
  background-size: 100% 100%;
  background: url("../../assets/images/002.png");
  &_pass {
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -250px;
    margin-top: -250px;
    border: 1px solid black;
    width: 500px;
    height: 500px;
    background: white;
    box-sizing: border-box;
    padding: 52px 70px 0 70px;
  }
  &_title {
    margin-bottom: 53px;
    width: 100%;
    height: 30px;
		line-height: 30px;
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4c4c4c;
    text-align: center;
  }
}
/* 注册样式 */
.live_regester_input {
  margin-top: 47px;
  margin-bottom: 50px;
  .cyl{
    width: 100%;
    height: 28px;
    display: flex;
    align-items: center;
  }
	.p2{
		border: none;
		display: flex;
		justify-content: space-between;
		input{
			width: 150px;
			border: 1px solid #7B7B7B;
		}
		.p2_right{
			border: 1px solid #7B7B7B;
			display: inline-block;
			width: 170px;
			height: 32px;
			border-radius: 4px;
			margin: 0;
      img{
        width: 80px;
        height: 30px;
        margin-left: 5px;
      }
      span{
        cursor: pointer;
        user-select: none;
        margin: 0;
        margin-left: 12px;
        i{
          font-size: 12px;
          font-style: italic;
          margin: 0;
        }
      }
		}
	}
  .p3{
    border: none;
    display: flex;
    justify-content: space-between;
    input{
      border: 1px solid #7B7B7B;
      border-radius: 2px;
      height: 36px;
      width: 200px;
      padding-left: 40px;
    }
    button{
      width: 150px;
      height: 36px;
      background: #D6E6FF;
      color: #1877F2;
      outline: none;
      border: none;
      border: 1px solid #1877F2;
      cursor: pointer;
    }
  }
  .span1{
    width: 255px;
    height: 16px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-left: 50px;
    margin-top: 100px;
    text-align: center;
    display: block;
    color: #1877F2;
  }
  p {
    margin-bottom: 20px;
    width: 356px;
    height: 34px;
    border-radius: 2px;
    border: 1px solid #7b7b7b;
    display: flex;
    align-items: center;
    border-radius: 2px;
    span {
      color: #525252;
      font-size: 14px;
      margin-left: 12px;
      margin-right: 12px;
    }
    input {
      border: none;
    }
    .live_regester_pass {
      margin-left: 13px;
      font-size: 14px;
      color: #c0c1c2;
    }
    .mask {
      background: rgba(0, 0, 0, 0.4) !important;
      border: none !important;
    }
  }
}
.live_login_nav {
  position: relative;
  left: 17px;
}
.ant-steps-small .ant-steps-item-icon {
  display: none !important;
}
.ant-steps-item-title::after {
  content: ". . . . ." !important;
  font-size: 20px !important;
}
.ant-steps-small .ant-steps-item-title::after {
  top: -6px !important;
}
.ant-steps-item-container {
  width: 100px;
}
</style>
